import ServiceFactory from "utilities/services/service-factory";
import { BlockRecord } from "models/view-models/block-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";

export interface BlockQueryParams {}

export interface BlockCreateParams {
    afterBlockId?: number;
    pageId: number;
    type: NotebookPageContentBlock;
}

export interface MoveBlockPathParams {
    movingBlockId: number;
    precedingBlockId?: number;
}

export interface BlockPathParams {
    id?: number;
}

const baseEndpoint = "blocks";
const resourceType = BlockRecord;
const moveEndpoint = `${baseEndpoint}/move`;
const resourceEndpoint = `${baseEndpoint}/:id`;

const BlockService = {
    create: ServiceFactory.createFromPostParams<BlockRecord, BlockCreateParams>(
        resourceType,
        baseEndpoint
    ),
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        BlockRecord,
        BlockCreateParams
    >(resourceType, baseEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
    move: ServiceFactory.patch<
        BlockRecord,
        BlockPathParams,
        MoveBlockPathParams
    >(resourceType, moveEndpoint),
    useMove: ServiceHookFactory.usePatch<
        Array<Array<number>>,
        BlockPathParams,
        MoveBlockPathParams
    >(Array, moveEndpoint),
};

export default BlockService;
